import { render } from "./ReadOnlyFormDisplay.vue?vue&type=template&id=c25ff41e&scoped=true"
import script from "./ReadOnlyFormDisplay.vue?vue&type=script&lang=js"
export * from "./ReadOnlyFormDisplay.vue?vue&type=script&lang=js"

import "./ReadOnlyFormDisplay.vue?vue&type=style&index=0&id=c25ff41e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c25ff41e"]])

export default __exports__